import React from "react";
import { Draggable } from "react-beautiful-dnd";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import style from "./GalleryItem.module.css";

import GalleryItem from "./GalleryItemContent";

export const GalleryItemDraggable = React.memo(
  ({
    item,
    index,
    handleEdit,
    handleDelete,
    someItemBeingDragged,
    disableAllEdits,
  }) => {
    return (
      <Draggable draggableId={item.uuid} index={index} key={item.uuid}>
        {(draggableProvided, draggableSnapshot) => (
          <GalleryItem
            item={item}
            handleEdit={handleEdit(item)}
            handleDelete={handleDelete(item)}
            isDragging={draggableSnapshot.isDragging}
            // TODO: figure out what draggableProvided.draggableProps are
            // and use the exact props needed instead of spreading everything
            {...draggableProvided.draggableProps}
            innerRef={draggableProvided.innerRef}
            someItemBeingDragged={someItemBeingDragged}
            disableAllEdits={disableAllEdits}
          >
            <span
              className={style.dragHandle}
              {...draggableProvided.dragHandleProps}
              title="Drag and drop from here to reorder"
            >
              <DragIndicatorIcon />
            </span>
          </GalleryItem>
        )}
      </Draggable>
    );
  }
);
GalleryItemDraggable.displayName = "Gallery Item Draggable";
// (prevProps, nextProps) => prevProps.item.uuid === nextProps.item.uuid
